import React from 'react';
import Helpline from './Helpline';
import { useTranslation } from 'react-i18next';
import BreadCrumbs from '../common/BreadCrumbs';
import Page from '../common/Page';

const HelplinePage = () => {

    const { t } = useTranslation();

    return (
        <Page>
            <BreadCrumbs stack={[
                {title: t("Domů"), path: "/"},
                {title: t("Helpline"), path: "/helpline"}
            ]} />
            <Helpline />
        </Page>
    );
};

export default HelplinePage;